import { S } from './Button.styles';
import type { ButtonProps } from './Button.types';

export const Button = ({ variant = 'filled', ...otherProps }: ButtonProps) => (
  <S.Button $internalVariant={variant} variant="unstyled" {...otherProps} />
);
